//
// Convert duration string to milliseconds
// Supported formats: '300ms', '30s', '20m', '1h', '1d', '1h20m30s'
//
export const getMs = (duration: string): number => {
  const units = {
    d: 86400000,
    h: 3600000,
    m: 60000,
    s: 1000,
    ms: 1,
  }

  return duration
    .match(/(\d+)(ms|d|h|m|s)/g)
    ?.reduce((total, part) => {
      const unit = part.match(/[a-z]+/)?.[0] as keyof typeof units
      const value = parseInt(part.replace(unit, ''), 10)
      return total + value * units[unit]
    }, 0) ?? 0
}

//
// Converts duration string to seconds (calls getMs and divides by 1000)
// Useful for APIs that expect seconds (e.g. networkTimeoutSeconds)
//
export const getSec = (duration: string): number => {
  return getMs(duration) / 1000
}
